import useMobile from '@fd/frontend/hooks/useMobile';

export function DesktopView({ children }: { children: React.ReactNode }) {
  const isMobile = useMobile();
  if (isMobile) return null;
  else return children;
}

export function MobileView({ children }: { children: React.ReactNode }) {
  const isMobile = useMobile();
  if (!isMobile) return null;
  else return children;
}
